<template>
  <div class="row justify-content-center email-validation-form">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center">
            <h3 class>Asociación de dispositivo</h3>
            <div class="row" v-if="Success && IsValidUser">
              <div class="col-md-12 text-center">
                <div style="margin-top:60px">El dispositivo fue vinculado a tu cuenta correctamente.</div>
                <div
                  style="margin-top:20px"
                >Podés gestionar tus dispositivos vinculados desde el módulo "Dispositivos Vinculados", luego que hayas iniciado sesión.</div>
                <div
                  style="margin-top:20px"
                >Volvé a la pantalla en que estabas para comenzar a usar tu billetera.</div>
              </div>
            </div>
            <div class="row" v-else-if="Success && IsValidUser == false">
              <div class="col-md-12 text-center">
                <div style="margin-top:60px">Por razones de seguridad, tu dispositivo y cuenta fueron bloqueados.</div>
                <div
                  style="margin-top:20px"
                >Detectamos inconvenientes en la vinculación de los mismos.</div>
                <div
                  style="margin-top:20px"
                >Comunicate con Mesa de Ayuda para completar éste paso.</div>
              </div>
            </div>
            <div v-else>
              <div>Hubo un error al asociar el dispositivo.</div>
              <div>Volvé a la ventana en la que estabas, e intentalo nuevamente.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.label-link {
  cursor: pointer;
}
</style>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  name: "NuevoInicioSesion",
  data() {
    return {
      Success: false,
      IsValidUser: false
    };
  },
  methods: {
    AssociateAccountDevice() {
      let context = this;

      context.IsValidUser = JSON.parse(context.$route.query.isValid);

      axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/AssociateAccountDevice",
        {
          Code: context.$route.query.verificationCode,
          IsValidUser: context.$route.query.isValid
        },
        this,
        function(data) {
          context.Success = data.ResponseVM.Success;
        }
      );
    }
  },
  beforeMount() {
    this.AssociateAccountDevice();
  }
};
</script>